import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { clusterApiUrl } from "@solana/web3.js";
import React from "react";
import { useMemo } from "react";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SlopeWalletAdapter } from "@solana/wallet-adapter-slope";
import { Coin98WalletAdapter } from "@solana/wallet-adapter-coin98";
import { ExodusWalletAdapter } from "@solana/wallet-adapter-exodus";
import { BackpackWalletAdapter } from "@solana/wallet-adapter-backpack";
require("@solana/wallet-adapter-react-ui/styles.css");

export interface IProps {
  children: any;
}

export const WalletWrapper: React.FC<IProps> = (props) => {
  const network = WalletAdapterNetwork.Devnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  const wallets = useMemo(
    () => [
      new SolflareWalletAdapter(),
      new PhantomWalletAdapter(),
      new BackpackWalletAdapter(),
      //new LedgerWalletAdapter(),
      new SlopeWalletAdapter(),
      new Coin98WalletAdapter(),
      new ExodusWalletAdapter(),
    ],
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider
        wallets={wallets}
        autoConnect
        onError={(e) => console.log(e)}
      >
        {props.children}
      </WalletProvider>
    </ConnectionProvider>
  );
};
